import { render } from "./LandingHeader.vue?vue&type=template&id=397e499d&scoped=true"
import script from "./LandingHeader.vue?vue&type=script&lang=js"
export * from "./LandingHeader.vue?vue&type=script&lang=js"

import "./LandingHeader.vue?vue&type=style&index=0&id=397e499d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397e499d"]])

export default __exports__